import DropDown from 'components/DropDown';
import PropTypes from 'prop-types';

import Quest from "components/Quest";

import { ReactComponent as ColumnsIcon } from 'icons/components/columns.svg';

import './index.less';
import './themes/default.less';

export default class Select extends DropDown {
    static propTypes = {
        ...DropDown.propTypes,
        showLeftIcon: PropTypes.bool,
        leftIcon: PropTypes.element,
        label: PropTypes.string,
        helpText: PropTypes.string,
        required: PropTypes.bool,
        caption: PropTypes.string,
    };
    static defaultProps = {
        ...DropDown.defaultProps,
        showLeftIcon: true,
        leftIcon: null,
        label: "",
        helpText: "",
        required: false,
        caption: "components.inputCaption",
    };

    get mainClassName() {
        return "select flex1";
    }

    getLeftIcon() {
        const { leftIcon, showLeftIcon } = this.props;

        return leftIcon || (showLeftIcon ? <ColumnsIcon className="leftIcon" /> : "");
    }

    renderSelector() {
        const { label, helpText, required, caption } = this.props;
        const reqSt = required ? " required" : "";
        const selector = super.renderSelector(...arguments);

        if (label) {
            return (
                <div ref={el => this.selectWrap = el} className="selectWrap flex col gap8">
                    <div className="flex between">
                        <div className={"selectLabel text p2" + reqSt}>{this.tr(label)}</div>
                        {!!helpText && <Quest textTooltip={helpText} size={14} />}
                    </div>
                    {selector}
                    <div ref={el => this.selectCaption = el} className="selectCaption text p2">{this.tr(caption)}</div>
                </div>
            );
        }

        return selector;
    }
}
